const CategoriesData = [
  {
    id: 1,
    name: "Rent",
    type: "Expense",
    isEnabled: false,
    budget: null,
    icon: "FaHome",
  },
  {
    id: 2,
    name: "Utilities",
    type: "Expense",
    isEnabled: false,
    budget: null,
    icon: "FaCogs",
  },
  {
    id: 3,
    name: "Food",
    type: "Expense",
    isEnabled: false,
    budget: null,
    icon: "FaRegLemon",
  },
  {
    id: 4,
    name: "Transport",
    type: "Expense",
    isEnabled: false,
    budget: null,
    icon: "FaTruckPickup",
  },
  {
    id: 5,
    name: "Salary",
    type: "Income",
    isEnabled: false,
    budget: null,
    icon: "FaCcVisa",
  },
  {
    id: 6,
    name: "Vacation",
    type: "Expense",
    isEnabled: false,
    budget: null,
    icon: "FaUmbrellaBeach",
  },
  {
    id: 7,
    name: "Apartment rent",
    type: "Income",
    isEnabled: false,
    budget: null,
    icon: "FaBuilding",
  },
];

export default CategoriesData;
